<template>
  <v-app id="app">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { uuid } from 'uuidv4';
export default {
  name: 'App',

  components: {},

  data: () => ({
  }),
  methods: {
    language () {
      if (localStorage.getItem("lang")) {
        this.$i18n.locale = localStorage.getItem("lang")
        return localStorage.getItem("lang")
      } else {
        localStorage.setItem("lang", "th")
        this.$i18n.locale = localStorage.getItem("lang")
        return localStorage.getItem("lang")
      }
    },
    setVersion() {
      localStorage.setItem("version", process.env.VUE_APP_VERSION)
    },
    setuuid() {
      sessionStorage.setItem("uuid", uuid())
    }
  },
  created() {
  },
  mounted() {
    this.language()
    this.setVersion()
    this.setuuid()
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Prompt:300,600&display=swap&subset=latin-ext,thai');
#app {
  /* font-family: 'Prompt', sans-serif; */
  /* font-family: 'Sarabun', Helvetica, Arial, sans-serif; */
  font-family: 'Prompt', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
    'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */
  background: #f1f2f5;
}
@media only screen and (max-width: 600px) {
  img {
    width: 210px;
    height: 140px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}
  @media only screen and (min-width: 601px) {
    img {
      width: 450px;
      height: 300px;
      margin-left: auto;
      margin-right: auto;
      display: block;
    }
  }
/* @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300&family=Sarabun:wght@300&display=swap&family=Kanit'); */
</style>
